export const PL_SLICE_OPTIONS = [
  { value: 'pnl_by_slice_asp_band', label: 'ASP Band' },
  { value: 'pnl_by_slice_everyday_essentials', label: 'Everyday Essentials' },
  { value: 'pnl_by_slice_fc_type', label: 'FC Type' },
  { value: 'pnl_by_slice_prime_plan', label: 'Prime Plan' },
  { value: 'pnl_by_slice_private_brands', label: 'Private Brands' }
];

export const PL_DRILL_DOWN_OPTIONS = [
  { value: 'pnl_drill_down_net_revenue', label: 'Net Revenue' },
  { value: 'pnl_drill_down_marketplace_revenue', label: 'Marketplace Rev' },
  { value: 'pnl_drill_down_net_fulfillment_revenue', label: 'Net Fulfillment Revenue' },
  { value: 'pnl_drill_down_net_ppm', label: 'Net PPM%' },
  { value: 'pnl_drill_down_vendor_profit', label: 'Vendor Profit' },
  { value: 'pnl_drill_down_gross_profit', label: 'Gross Profit' },
  { value: 'pnl_drill_down_contribution_profit', label: 'Contribution Profit' },
  { value: 'pnl_drill_down_cp_less_ops_field_fixed', label: 'CP Less Ops Field Fixed' },
  { value: 'pnl_drill_down_operating_income', label: 'Operating Income' }
];
